import React, { Component } from 'react';
import { isEqual } from 'lodash';
import { withTheme } from 'styled-components';
import helpers from 'helpers';
import PropTypes from 'prop-types';
import DonutChart from 'components/molecules/charts/DonutChart';

class GeoDonutChart extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data) || !isEqual(nextProps.total, this.props.total);
    }

    render() {
        const { data, orderedGeos, formatName, ...props } = this.props;
        const { orderedColors } = this.props.theme;

        const seriesData = [];

        orderedGeos.forEach((n, index) => {
            if (!data[n]) {
                return;
            }

            seriesData.push({
                name: formatName ? helpers.convertToDisplayValue(n) : n,
                y: data[n],
                color: orderedColors[index % orderedColors.length]
            });
        });

        return (
            <DonutChart {...props}
                data={seriesData} />
        );
    }
}

GeoDonutChart.propTypes = {
    orderedGeos: PropTypes.arrayOf(PropTypes.string).isRequired,
    data: PropTypes.object.isRequired
};

export default withTheme(GeoDonutChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/labs/GeoDonutChart.js